import React from 'react';
import c from '../w.js';

const IconStaticStatusWarning = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.1215 2.70705C12.9499 1.53548 11.0504 1.53547 9.87887 2.70705L2.70729 9.87862C1.53572 11.0502 1.53572 12.9497 2.70729 14.1213L9.87887 21.2928C11.0504 22.4644 12.9499 22.4644 14.1215 21.2928L21.2931 14.1213C22.4647 12.9497 22.4647 11.0502 21.2931 9.87862L14.1215 2.70705Z",
        fill: "#F59E00"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 13V7H13V13H11ZM11 17V15H13V17H11Z",
        fill: "#000"
      }
    ))
  )
);

export { IconStaticStatusWarning };
